import UserConsent from "../components/UserConsent";
import "./AdStreamStyle.css";
import Menu from "../components/Menu";
import Footer from "../components/Footer";

const APP_STORE_URL =
  "https://apps.apple.com/us/app/fawesome/id1063891742?platform=iOS";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.future.moviesByFawesomeAndroidTV&hl=en_US&gl=US";

const PLATFORMS = [
  {
    name: "Roku",
    icon: "ico-roku.webp",
    url: "https://channelstore.roku.com/details/c54dacc6b0b084f18629f8c6cbc4de3e:e29d4786bf1083e800ab864570452e28/fawesome-free-movies-and-tv-shows",
  },
  {
    name: "Fire TV",
    icon: "ico-fireTV.webp",
    url: "https://www.amazon.com/Future-Today-Inc-Movies-Fawesome-tv/dp/B076X8FKXP/",
  },
  {
    name: "Apple TV",
    icon: "ico-appleTV.webp",
    url: "https://apps.apple.com/us/app/fawesome/id1063891742?platform=appleTV",
  },
  {
    name: "Google TV",
    icon: "ico-googleTV.svg",
    url: "https://play.google.com/store/search?q=fawesome&c=apps",
  },
  {
    name: "LG",
    icon: "ico-LG.webp",
    url: "https://us.lgappstv.com/main/tvapp/detail?appId=458741",
  },
  {
    name: "Samsung",
    icon: "ico-sam.webp",
    // url: "https://www.samsung.com/us/apps/",
  },
  {
    name: "Vizio",
    icon: "ico-vizio.webp",
    // url: "https://www.vizio.com/en/smart-tv-apps",
  },
  { name: "Vidaa", icon: "ico-vidaa.webp", /*url: "https://www.vidaa.com/" */},
  {
    name: "Xbox",
    icon: "ico-xbox.webp",
    // url: "https://www.xbox.com/en-US/entertainment/console-apps",
  },
  {
    name: "Xfinity",
    icon: "ico-xfinity.webp",
    // url: "https://www.xfinity.com/apps",
  },
  {
    name: "Xumo",
    icon: "ico-xumo.webp",
    // url: "https://www.xumo.com/products/xumo-tv",
  },
  { name: "Cox", icon: "ico-cox.webp", url: null },
  {
    name: "Rogers",
    icon: "ico-rogers.webp",
    // url: "https://www.rogers.com/support/apps",
  },
  { name: "Shaw", icon: "ico-shaw.webp", /*url: "https://support.shaw.ca/" */},
  {
    name: "Windows",
    icon: "ico-windows.webp",
    url: "https://apps.microsoft.com/detail/9p55dw09xk2d?hl=en-us&gl=US",
  },
];

function PlatformIcon({ name, icon, url }) {
  const image = (
    <img
      className="platform-icon"
      src={`./assets/images/app/${icon}`}
      alt={name}
      loading="lazy"
    />
  );

  return (
    <li>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="gtm-adstream gtm-platform-link"
        >
          {image}
        </a>
      ) : (
        image
      )}
    </li>
  );
}

function AdStreamPage() {
  return (
    <>
      <div className="ad-stream-menu">
        <Menu />
      </div>

      <div className="ad-stream-page">
        <section className="download-app padding-40">
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className="download-info ad-stream-animate">
                  <img
                    className="ad-stream-logo padding-40"
                    src="./assets/images/logo.svg"
                    alt="Fawesome"
                  />
                  <h1 className="title-big">
                    Entertainment <small>for you</small>
                  </h1>
                  <h2>100% free · No subscription</h2>
                  <p>
                    Stream free movies and TV shows on the Fawesome app. No
                    subscription, no fees — just press play.
                  </p>

                  <div className="buttons social-btn padding-40">
                    <a
                      href={PLAY_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-googleplay gtm-adstream gtm-store-btn"
                    >
                      <img src="./assets/images/google-play.png" alt="" />
                      <span className="text">
                        <i>Get it now</i>
                        Google Play
                      </span>
                    </a>
                    <a
                      href={APP_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-appstore gtm-adstream gtm-store-btn"
                    >
                      <img src="./assets/images/apple.png" alt="" />
                      <span className="text">
                        <i>Get it now</i>
                        App Store
                      </span>
                    </a>
                  </div>

                  <div className="qr social-btn btn btn-qr">
                    <img
                      src="./assets/images/qr-code-ad.png"
                      alt="Fawesome app QR code"
                    />
                    <h2>Watching on TV?</h2>
                    <p>Point your phone camera here to get the free app.</p>
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div className="app-phone">
                  <img
                    src="./assets/images/device.png"
                    alt="Fawesome app on mobile"
                  />
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-md-4">
                <div className="download-info">
                  <div className="qr social-btn btn ">
                    <h2>Also free on your TV, tablet & web</h2>
                    <img
                      className="device-img"
                      src="./assets/images/device-all.png"
                      alt="Fawesome on TV, tablet and web"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-8">
                <ul className="social-icon ad-stream-animate">
                  {PLATFORMS.map((platform) => (
                    <PlatformIcon key={platform.name} {...platform} />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>

      <UserConsent />
      <Footer/>
    </>
  );
}

export default AdStreamPage;
